<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/B6irBX/tc-custom/9783987447228.jpg?1704424985963" alt="This image is the cover for the book Galactic Patrol, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Galactic Patrol, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Galactic Patrol is a science fiction novel by American author E. E. Smith. The novel was originally serialized in the magazine Astounding in 1937. The stories in this volume were the first parts written of the original Lensman saga. It was later published in book form in 1950 by Fantasy Press. Although portions of Triplanetary were written earlier, they were not originally part of the Lensman story and were only later revised to connect them to the rest of the series. First Lensman was written later to bridge the events in Triplanetary to those in Galactic Patrol.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        E. E. Smith
      </h2>
      
      <p class="authorDescription body article">Edward Elmer Smith (May 2, 1890 – August 31, 1965), publishing as E. E. Smith, Ph.D. and later as E. E. "Doc" Smith, was an American food engineer (specializing in doughnut and pastry mixes) and science-fiction author, best known for the Lensman and Skylark series. He is sometimes called the father of space opera.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2f547224